import { forwardRef } from 'preact/compat';
import { tryFocus } from '@/utils';
import { useConfigStore } from '../stores/ConfigStore';
import { useFormStore } from '../stores/FormStore';
import HandleTabIndex from '@/features/elements/components/HandleTabIndex';

const CloseButton = forwardRef(function CloseButton(props, ref) {
	const { text } = useConfigStore();
	const { feedbackButtonRef, shiftFocusToTopRef, actions } = useFormStore();
	return (
		<HandleTabIndex
			component="button"
			type="button"
			id="closeModalBtn"
			ref={ref}
			title={text.closeBtnTitle}
			aria-label={text.closeBtnTitle}
			className={'close-modal wcag'}
			onClick={() => {
				actions.toggleForm();
			}}
			style={{
				backgroundColor: 'transparent',
				boxShadow: 'none',
				border: 'none'
			}}
			data-testid="close"
			onKeyDown={e => {
				if (e.key === 'Enter') {
					tryFocus(feedbackButtonRef.current);
				}
				if (e.key === 'Tab' && e.shiftKey) {
					e.preventDefault();
					tryFocus(shiftFocusToTopRef.current);
				}
			}}
		/>
	);
});

export default CloseButton;
